const DocumentDraft = {
  ReceivedDocuments: "DocumentDraft.ReceivedDocuments",
  State_0: "DocumentDraft.State_0",
  State_1: "DocumentDraft.State_1",
  State_2: "DocumentDraft.State_2",
  State_3: "DocumentDraft.State_3",
  Type_0: "DocumentDraft.Type_0",
  Type_1: "DocumentDraft.Type_1",
  Type_2: "DocumentDraft.Type_2",
  Type_3: "DocumentDraft.Type_3",
  Type_4: "DocumentDraft.Type_4",
  Type_5: "DocumentDraft.Type_5",
  Source_0: "DocumentDraft.Source_0",
  Source_1: "DocumentDraft.Source_1",
  Source_2: "DocumentDraft.Source_2",
  DocumentEmailBannerTitle: "DocumentDraft.DocumentEmailBannerTitle",
  DocumentEmailBannerSubTitle: "DocumentDraft.DocumentEmailBannerSubTitle",
  YoureMailAddress: "DocumentDraft.YoureMailAddress",
  BannerReadMoreOnDocumentEmail: "DocumentDraft.BannerReadMoreOnDocumentEmail",
  SelfInvoiceEmailBannerTitle: "DocumentDraft.SelfInvoiceEmailBannerTitle",
  SelfInvoiceEmailBannerSubTitle: "DocumentDraft.SelfInvoiceEmailBannerSubTitle",
  BannerReadMoreOnSelfInvoiceEmail: "DocumentDraft.BannerReadMoreOnSelfInvoiceEmail",
  SubmittedDocument: "DocumentDraft.SubmittedDocument",
  SelectionPanelHeaderSubText: "DocumentDraft.SelectionPanelHeaderSubText",
  CreatedSelectionPanelHeaderSubText: "DocumentDraft.CreatedSelectionPanelHeaderSubText",
  CreatedSelectionPanelSelfInvoiceHeaderText: "DocumentDraft.CreatedSelectionPanelSelfInvoiceHeaderText",
  RemovedSelectionPanelSelfInvoiceHeaderText: "DocumentDraft.RemovedSelectionPanelSelfInvoiceHeaderText",
  CreatedSelectionPanelSelfInvoiceHeaderSubText: "DocumentDraft.CreatedSelectionPanelSelfInvoiceHeaderSubText",
  DeletedSelectionPanelHeaderSubText: "DocumentDraft.DeletedSelectionPanelHeaderSubText",
  SelectionPanelHeaderText: "DocumentDraft.SelectionPanelHeaderText",
  ApproveSuccessMessage: "DocumentDraft.ApproveSuccessMessage",
  CancelSuccessMessage: "DocumentDraft.CancelSuccessMessage",
  Received: "DocumentDraft.Received",
  SentBy: "DocumentDraft.SentBy",
  NoSender: "DocumentDraft.NoSender",
  NoSubject: "DocumentDraft.NoSubject",
  Handled: "DocumentDraft.Handled",
  DocumentDeleted: "DocumentDraft.DocumentDeleted",
  DocumentDeletedDescription: "DocumentDraft.DocumentDeletedDescription",
  RemovedTodoTitle: "DocumentDraft.RemovedTodoTitle",
  RemovedTodoText1: "DocumentDraft.RemovedTodoText1",
  RemovedTodoText2: "DocumentDraft.RemovedTodoText2",
  MarkAsRead: "DocumentDraft.MarkAsRead",
  ShowReceipt: "DocumentDraft.ShowReceipt",
  ShowInvoice: "DocumentDraft.ShowInvoice",
  ShowGenericDocument: "DocumentDraft.ShowGenericDocument",
  ShowSelfInvoice: "DocumentDraft.ShowSelfInvoice",
  GenericDocumentSelectionInfoBannerPart1: "DocumentDraft.GenericDocumentSelectionInfoBannerPart1",
  GenericDocumentSelectionInfoBannerBoldText: "DocumentDraft.GenericDocumentSelectionInfoBannerBoldText",
  GenericDocumentSelectionInfoBannerPart2: "DocumentDraft.GenericDocumentSelectionInfoBannerPart2",
  }
export default DocumentDraft;